import store from "@/store";
import routesMap from "@/router/routesMap";
let build = false;
export default {
  buildRoute: async (router) => {
    if (build) {
      return Promise.resolve(true);
    }
    return store
      .dispatch("permissionStore/listUserPermission", {
        request: JSON.stringify({ isGetCacheDta: false }),
      })
      .then((res) => {
        let permissionTree = res.items;
        let permissionMap = {};
        let permissionTempStack = [...permissionTree];
        let cp;
        while ((cp = permissionTempStack.pop()) != null) {
          if (cp.roleIsPermission === true) {
            permissionMap[cp.code] = cp;
          }
          let children = cp.children;
          if (children != null && children.length) {
            permissionTempStack.push(...children);
          }
        }

        let tempStack = [...routesMap];
        let currentRoute;
        let parentStack = [];
        let currentParent = null;
        while ((currentRoute = tempStack.pop()) != null) {
          let children = currentRoute.children;

          if (currentParent != null) {
            if (currentParent.num <= 0) {
              if (parentStack.length > 0) {
                currentParent = parentStack.pop();
              } else {
                currentParent = null;
              }
            } else {
              currentParent.num--;
            }
          }
          if (children != null && children.length > 0) {
            if (currentParent != null) {
              parentStack.push(currentParent);
            }
            currentParent = { route: currentRoute, num: children.length };
            tempStack.push(...children);
          } else {
            const { permissionRoute, permissionAction } = currentRoute.meta || {};
            const permissionName = permissionRoute || currentRoute.name;
            let routePermission = permissionMap[permissionName];
            if (
              routePermission == null ||
              routePermission.roleIsPermission != true ||
              (permissionAction &&
                !(routePermission.children || []).some(child =>
                  child.type === 4 && child.roleIsPermission === true &&
                  child.code === permissionName + ":" + permissionAction
                ))
            ) {
              currentParent.route.children.splice(currentParent.num, 1);
            } else {
              let permission = null;

              if (
                routePermission.children != null &&
                routePermission.children.length > 0
              ) {
                permission = {};
                for (let i in routePermission.children) {
                  let child = routePermission.children[i];
                  if (child.type === 4 && child.roleIsPermission === true) {
                    permission[child.code] = child;
                  }
                }
              }
              currentRoute.meta = { ...currentRoute.meta, permission };
            }
          }
        }
        router.addRoutes(routesMap);
        build = true;
        return Promise.resolve(true);
      })
      .catch((reason) => {
        return Promise.resolve(false);
      });
  },
};
